import { addSignTemplate, updateSignTemplate } from '@/services/goods'
import { Form, Input, message } from 'antd'
import { useEffect, useState } from 'react'
import { STriggerModal } from 'shj-components'

const AddOrRenameModal = (props: {
  isAdd: boolean
  clickInfo: any
  listRef: any
  open: boolean
  onCancel: () => void
}) => {
  const { open, onCancel, isAdd, clickInfo, listRef } = props
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  // 新增模版
  const addTemplate = (name: string, remark: string) => {
    setLoading(true)
    addSignTemplate({
      name,
      remark,
    })
      .then(() => {
        message.success('新增成功')
        onCancel()
        listRef.current.reload()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 重命名模版
  const renameTemplate = (name: string, remark: string) => {
    setLoading(true)
    updateSignTemplate({
      name,
      remark,
      id: clickInfo.id,
    })
      .then(() => {
        message.success('重命名成功')
        onCancel()
        listRef.current.reload()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 点击确定
  const handleOk = async () => {
    form
      .validateFields()
      .then(() => {
        const { name, remark } = form.getFieldsValue()
        isAdd ? addTemplate(name, remark) : renameTemplate(name, remark)
      })
      .catch(err => {
        console.log('err', err)
      })
  }

  useEffect(() => {
    if (clickInfo && open) {
      form.setFieldsValue({
        name: clickInfo.name,
        remark: clickInfo.remark,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [clickInfo, form, open])

  return (
    <STriggerModal
      title={isAdd ? '新增模板' : '重命名'}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      width={500}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" initialValues={clickInfo}>
        <Form.Item
          label="模板名称"
          name="name"
          rules={[{ required: true, message: '请输入模板名称' }]}
        >
          <Input placeholder="请输入模板名称" maxLength={30} showCount />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <Input.TextArea rows={4} showCount maxLength={200} placeholder="请输入备注" />
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default AddOrRenameModal
